import React, { Component, Fragment } from 'react';

import { Modal } from 'components/modal';
import { I18n } from 'components/translate';
import { modalTypes } from 'modules/salesManager/constants';
import PropTypes from 'prop-types';

import { Checkbox } from '../../../components/input';

import './SalesGroupModal.scss';

export default class SalesGroupModal extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    registerMetrics: PropTypes.func,
    type: PropTypes.string
  };

  state = {
    first: false,
    second: false,
    third: false
  };

  onCheckboxChange(condition) {
    const obj = {};
    const { type, registerMetrics } = this.props;

    obj[condition] = !this.state[condition];
    this.setState(obj);

    const eventSection = type === 'activate' ? 'ACTIVATE' : 'DEACTIVATE';

    registerMetrics?.(`MODAL_${eventSection}_CONDITION`, condition);
  }

  allChecked() {
    const { first, second, third } = this.state;
    const { type } = this.props;

    const allConditionsIsChecked =
      type === 'change' || type === 'activate'
        ? first && second
        : first && second && third;

    return allConditionsIsChecked;
  }

  render() {
    const { onCancel, onConfirm, type } = this.props;
    const modalType = modalTypes[type];

    return (
      <Modal title={modalType.title} onClose={onCancel}>
        <Modal.Body>
          <p>
            <I18n label={modalType.description} />
            <I18n label="sales_manager.sales_group.modal.confirm_change_below" />
          </p>

          <div className="salesgroupmodal__terms">
            <Fragment>
              {modalType.conditions.map((item) => {
                return (
                  <Checkbox
                    key={item.condition}
                    checked={this.state[item.condition]}
                    onChange={() => this.onCheckboxChange(item.condition)}
                  >
                    <I18n label={item.description} />
                  </Checkbox>
                );
              })}
            </Fragment>
          </div>

          <p>
            <I18n label="general.are_u_sure" />
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="hot-button hot-button--primary hot-button--lg"
            onClick={onConfirm}
            disabled={!this.allChecked()}
          >
            <I18n label="general.ok" />
          </button>
          <button
            className="hot-button hot-button--secondary hot-button--lg"
            onClick={onCancel}
          >
            <I18n label="general.cancel" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
